import { apiInstanceFetch } from "../../../util/api";
import axios from "axios";
import * as ActionType from "./supportChat.type";
import { setToast } from "../../../util/toast";

// Get all support conversations
export const getSupportConversations = (page, limit, status, priority) => (dispatch) => {
  let url = `support/admin/all?page=${page}&limit=${limit}`;
  if (status && status !== "all") url += `&status=${status}`;
  if (priority && priority !== "all") url += `&priority=${priority}`;

  apiInstanceFetch
    .get(url)
    .then((res) => {
      dispatch({
        type: ActionType.GET_SUPPORT_CONVERSATIONS,
        payload: {
          data: res.conversations,
          total: res.pagination?.total || 0,
          stats: res.stats || null,
        },
      });
    })
    .catch((error) => console.error(error));
};

// Get conversation details with messages
export const getSupportConversationDetails = (conversationId) => (dispatch) => {
  apiInstanceFetch
    .get(`support/admin/details?conversationId=${conversationId}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_SUPPORT_CONVERSATION_DETAILS,
        payload: {
          conversation: res.conversation,
          messages: res.messages,
        },
      });
    })
    .catch((error) => console.error(error));
};

// Update status
export const updateSupportStatus = (conversationId, status, adminId) => (dispatch) => {
  axios
    .patch(`support/admin/status`, { conversationId, status, adminId })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_SUPPORT_STATUS,
          payload: { data: res.data.conversation, id: conversationId },
        });
        setToast("success", "Status updated successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

// Update priority
export const updateSupportPriority = (conversationId, priority) => (dispatch) => {
  axios
    .patch(`support/admin/priority`, { conversationId, priority })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_SUPPORT_PRIORITY,
          payload: { data: res.data.conversation, id: conversationId },
        });
        setToast("success", "Priority updated successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

// Assign agent
export const assignAgent = (conversationId, agentId) => (dispatch) => {
  axios
    .patch(`support/admin/assign`, { conversationId, agentId })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.ASSIGN_AGENT,
          payload: { data: res.data.conversation, id: conversationId },
        });
        setToast("success", res.data.message);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

// Send message
export const sendSupportMessage = (conversationId, senderId, senderType, content) => (dispatch) => {
  axios
    .post(`support/send`, { conversationId, senderId, senderType, content })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.SEND_SUPPORT_MESSAGE,
          payload: res.data.data,
        });
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

// Delete message
export const deleteSupportMessage = (messageId) => (dispatch) => {
  axios
    .delete(`support/admin/deleteMessage`, { data: { messageId } })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_SUPPORT_MESSAGE,
          payload: messageId,
        });
        setToast("success", "Message deleted successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

// Get support stats
export const getSupportStats = () => (dispatch) => {
  apiInstanceFetch
    .get(`support/admin/stats`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_SUPPORT_STATS,
        payload: res.stats,
      });
    })
    .catch((error) => console.error(error));
};

// Add internal note
export const addInternalNote = (conversationId, note) => (dispatch) => {
  axios
    .patch(`support/admin/note`, { conversationId, note })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.ADD_INTERNAL_NOTE,
          payload: { data: res.data.conversation, id: conversationId },
        });
        setToast("success", "Note updated successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

// Clear conversation details
export const clearSupportConversationDetails = () => (dispatch) => {
  dispatch({
    type: ActionType.CLEAR_SUPPORT_CONVERSATION_DETAILS,
  });
};

// Mark messages as read (for admin)
export const markSupportMessagesAsRead = (conversationId) => (dispatch) => {
  axios
    .post(`support/markAsRead`, { conversationId, readerType: "Admin" })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.MARK_SUPPORT_READ,
          payload: conversationId,
        });
      }
    })
    .catch((error) => console.error(error));
};

// Admin creates a new conversation with a user
export const createSupportConversation = (userId, subject, adminId, navigate) => (dispatch) => {
  axios
    .post(`support/admin/create`, { userId, subject, adminId })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.CREATE_SUPPORT_CONVERSATION,
          payload: res.data.conversation,
        });
        if (res.data.isExisting) {
          setToast("info", "User already has an active conversation — opening it");
        } else {
          setToast("success", "Conversation created successfully");
        }
        if (navigate) {
          navigate("/admin/supportChatDetails", { state: res.data.conversation._id });
        }
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

// Send image message
export const sendSupportImage = (conversationId, senderId, senderType, imageFile) => (dispatch) => {
  const formData = new FormData();
  formData.append("conversationId", conversationId);
  formData.append("senderId", senderId);
  formData.append("senderType", senderType);
  formData.append("image", imageFile);

  axios
    .post(`support/sendImage`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.SEND_SUPPORT_MESSAGE,
          payload: res.data.data,
        });
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};
